import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
};

export default class DemonstrationApi {

    private endPointName = "demonstration";

    public setEndPointName(isRevenueDemonstration:boolean) {
        if(isRevenueDemonstration){
            this.endPointName = "demonstration-revenue";
        }
    }

    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}`;

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url =  `${RESOURCE_ENDPOINT}${this.endPointName}/${Number(id)}`;
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}`;
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url =`${RESOURCE_ENDPOINT}${this.endPointName}/${Number(id)}`
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}/${Number(id)}`
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}/${id}`
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}/bulk`
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${RESOURCE_ENDPOINT}${this.endPointName}/dropdown`
        return HttpService.get(url, params, headers);
    };
}
